<div class="exception-body mobile-fields" >
  <div class="exception-content">
    <div class="exception-detail access-revoked">
      <div class="grid">
        <p-card class="card-custom">
          <div class="card-custom-padding">
            <img ngSrc="../../../../assets/images/delegate-user/revoke-access.jpg" alt="" height="248" width="248">
            <p class="access-revoked-headline">Access Unavailable!</p>
            <p class="access-revoked-sub-headline">Your access permissions have been revoked by the delegator or the delegation period has ended and<br>
              access is no longer available.<br> Please contact them directly for further details or assistance.</p>

            <button pButton class="p-button p-button-lg create-btn" (click)="returnToMyProfile()"
                    iconPos="left" icon="fa-solid fa-arrow-left" label="Return to my profile"
            ></button>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</div>
